const UNIT_TYPE_LABEL = {
  0: "grams",
  1: "kg",
  2: "ml",
  3: "l",
};

function generateSlug(product) {
  const nameSlug = product?.title
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-");

  return `${nameSlug}-${btoa(product.id)}`;
}

export default {
  UNIT_TYPE_LABEL,
  generateSlug,
};
